module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_Black.1aed5e43.jpg";